<div class="flex justify-end mb-4 mt-4">
  <div class="min-w-64 flex justify-end flex-row items-end gap-5">
    <app-contributor-filter-dropdown
      [projectId]="projectId()"
      [showAverageOption]="showAverageOption()"
      (contributorSelected)="contributorSelected.emit($event)"
    ></app-contributor-filter-dropdown>
    <app-step-dot-menu
      class="-mb-3"
      [projectId]="projectId()"
      [testId]="dotMenuTestId()"
      [preselectedRole]="preselectedRole()"
      [preselectedAccessiblePages]="preselectedAccessiblePages()"
    ></app-step-dot-menu>
  </div>
</div>
